import { render } from "./MarketingCampaign.component.vue?vue&type=template&id=565ff19e"
import script from "./MarketingCampaign.component.vue?vue&type=script&lang=js"
export * from "./MarketingCampaign.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__